<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">TÉRMINOS Y CONDICIONES</h1>

      <p>
        Al utilizar la aplicación Tipsong usted acepta expresamente los siguientes términos:
      </p>

      <br />
      <h6>1. Uso de la aplicación</h6>
      <p>
        La app está diseñada para ofrecer información sobre eventos musicales, venta de boletos, merchandising y contenido de artistas. El uso indebido o fraudulento de la aplicación será motivo de suspensión inmediata del servicio y podría generar acciones legales pertinentes.
      </p>

      <br />
      <h6>2. Registro y seguridad de la cuenta</h6>
      <p>
        Es responsabilidad del usuario mantener la confidencialidad de sus credenciales de acceso. El usuario deberá notificar inmediatamente a Tipsong ante cualquier uso no autorizado de su cuenta. Tipsong no será responsable de pérdidas derivadas del incumplimiento por parte del usuario de esta obligación.
      </p>

      <br />
      <h6>3. Compras y devoluciones</h6>
      <p>
        Las compras realizadas a través de Tipsong son finales. Sin embargo, en caso de cancelación de un evento, se realizará un reembolso según las políticas específicas indicadas al momento de la compra. Los reembolsos pueden tardar hasta 30 días hábiles en ser procesados.
      </p>

      <br />
      <h6>4. Condiciones de pago</h6>
      <p>
        Los pagos realizados en Tipsong deberán efectuarse a través de métodos autorizados y seguros disponibles en la plataforma. Tipsong se reserva el derecho a verificar cualquier transacción para evitar fraudes o incumplimientos.
      </p>

      <br />
      <h6>5. Propiedad intelectual</h6>
      <p>
        Todo contenido disponible en Tipsong, incluyendo música, imágenes, textos, marcas, logos, software y diseño gráfico, son propiedad exclusiva de Tipsong o sus socios y están protegidos por derechos de propiedad intelectual y tratados internacionales. Está prohibido el uso no autorizado o reproducción del contenido disponible.
      </p>

      <br />
      <h6>6. Responsabilidad del usuario</h6>
      <p>
        Los usuarios aceptan utilizar la plataforma de manera adecuada y lícita, absteniéndose de realizar actividades que pudieran causar daños, perjuicios o afectar la reputación de Tipsong, otros usuarios o terceros.
      </p>

      <br />
      <h6>7. Responsabilidad y exoneración</h6>
      <p>
        Tipsong no es responsable por cambios en eventos, cancelaciones, retrasos, pérdidas, daños personales o materiales, u otros incidentes que puedan ocurrir antes, durante o después de los eventos. Toda reclamación relacionada deberá dirigirse directamente al organizador del evento correspondiente.
      </p>

      <br />
      <h6>8. Privacidad y seguridad</h6>
      <p>
        Consulte nuestro Aviso de Privacidad para conocer en detalle cómo protegemos y utilizamos sus datos personales.
      </p>

      <br />
      <h6>9. Suspensión del servicio</h6>
      <p>
        Tipsong se reserva el derecho a suspender o cancelar cuentas que incumplan con estos términos o afecten negativamente la plataforma o la experiencia de otros usuarios.
      </p>

      <br />
      <h6>10. Modificaciones</h6>
      <p>
        Estos términos pueden ser modificados por Tipsong en cualquier momento. Dichas modificaciones serán notificadas mediante la app y/o correo electrónico registrado por el usuario. El uso continuado de la aplicación tras la notificación constituirá aceptación expresa de las modificaciones.
      </p>

      <br />
      <h6>11. Legislación aplicable y jurisdicción</h6>
      <p>
        Estos términos se regirán e interpretarán conforme a las leyes aplicables en el país donde opera Tipsong, y cualquier controversia será sometida a la jurisdicción de los tribunales competentes en dicho territorio.
      </p>
      <p>
        Al continuar usando Tipsong usted reconoce haber leído, entendido y aceptado tanto el Aviso de Privacidad como los presentes Términos y Condiciones.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
